import React, { JSX } from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { LzTFunctionSimple, LzTAlignments, LzTColors } from "@lz/typings";

export interface LzPButtonsBarButton {
    title: string,
    type?: 'button' | 'submit',
    color?: LzTColors,
    variant?: 'text' | 'outlined' | 'contained';
    icon?: JSX.Element;
    onClick?: LzTFunctionSimple;
    route?: string;
}

export interface LzPButtonsBar {
    paddingTop?: number,
    paddingBottom?: number,
    align?: LzTAlignments,
    buttons: LzPButtonsBarButton[];
}

const LzXButtonsBar = (props: LzPButtonsBar) => {
    const getButton = (btn: LzPButtonsBarButton, dex: number): JSX.Element =>
        <Button
            key={'btn-' + dex}
            type={btn.type || 'button'}
            color={btn.color || 'primary'}
            variant={btn.variant || 'text'}
            startIcon={btn.icon}
            style={{ marginLeft: 10 }}
            onClick={btn.onClick}
        >{btn.title}</Button>;

    return (
        <div style={{
            paddingTop: typeof props.paddingTop !== 'undefined' ? props.paddingTop : 16,
            paddingBottom: typeof props.paddingBottom !== 'undefined' ? props.paddingBottom : 16,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left' === props.align ? 'flex-start' : ('center' === props.align ? 'center' : 'flex-end'),
        }}>
            {props.buttons.map((btn, dex) =>
                <React.Fragment>
                    {(typeof btn.route !== 'undefined' && btn.route !== '') ?
                        <Link to={btn.route} >{getButton(btn, dex)}</Link>
                        :
                        getButton(btn, dex)
                    }
                </React.Fragment>
            )}
        </div>

    );
};

export default LzXButtonsBar;
